import { useEffect, useState } from 'react';

interface User {
  email?: string;
  sub?: string;
  name?: string;
}

interface Session {
  user: User;
  isAuthenticated: boolean;
}

export const useSession = () => {
  const [session, setSession] = useState<Session | null>(null);
  const [status, setStatus] = useState<'loading' | 'authenticated' | 'unauthenticated'>('loading');

  useEffect(() => {
    const checkSession = () => {
      // Check authentication status via JWT validation
      fetch('/api/auth/session-check', {
        method: 'GET',
        credentials: 'include',
      })
        .then(response => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error('Not authenticated');
          }
        })
        .then(data => {
          setSession({
            user: {
              email: data.email,
              sub: data.sub,
              name: data.name,
            },
            isAuthenticated: true,
          });
          setStatus('authenticated');
        })
        .catch(() => {
          setSession(null);
          setStatus('unauthenticated');
        });
    };

    checkSession();

    // Check session every 30 seconds to detect changes
    const interval = setInterval(checkSession, 30000);

    return () => clearInterval(interval);
  }, []);

  return {
    data: session,
    status,
  };
};

// Keep the old export for backward compatibility during transition
export const useOktaSession = useSession;
